import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import CommonComments from './../../../common/Comments';
import PaginationComponent from './../../../common/Pagination';
import { GET_REPORT_DATA, UPDATE_DESCRIPTION_DATA } from '../../../../appRedux/actions/ReportDetailAction';
import { ReportType, ModuleType, makeLinkForQuickbooks, numberWithCommas,LinkType} from '../../../common/commonServices'
import moment from 'moment';
import { bindActionCreators } from 'redux';
import CircularProgress from './../../../../components/CircularProgress';
import { toast } from 'react-toastify';
import {MarkReportReview,GetReportReviewedHistory, LedgerUpdate } from '../../../../appRedux/actions/LedgerAction';
import { Accounts } from '../../../../appRedux/actions/accountAction';
import Tooltip from '@material-ui/core/Tooltip';
import TransactionEditRow from '../../../common/TransactionEditRow';
import { formatNewAccountLabel, toAccountOptions, startSave, handleLedgerResult, handleMemoResult } from '../../../common/transactionEdit';
import './DataEntryIssues.css';

class OOTranComponent extends Component {

    constructor(props) {
        super(props);

        this.state = {
            parantData: this.props.location.state ? this.props.location.state : null,
            MissingData: [],
            sortField: 'date',
            sortFormat: "D",
            PageNo: 1,
            PageSize: 10,
            ColorCode: "#e27b40",
            sDate: new Date(2019, 0, 1),
            eDate: new Date(),
            loading: false,
            TotalRecords: 0,
            CommentReferenceId: 0,
            IsEmbeddedPage: false,
            ShowHistory:true,
            HistoryData:[],
            // Transaction edit row
            editIndex: -1,
            accounts: [],
            accountOptions: [],
            pendingDescriptionBody: null,
            pendingTfbOnlySave: false
        }
    }

    onRowClick = (j) => {
        this.setState({ editIndex: this.state.editIndex === j ? -1 : j });
    }

    onRowSave = (item, editData) => {
        startSave(this, item, editData, ReportType.OutstandingTransection);
    }

    onSortChange = (fieldName) => {
        if (this.state.sortField == fieldName) {
            let formate = this.state.sortFormat == 'A' ? 'D' : 'A';
            this.setState({ sortFormat: formate, loading: true }, () => {
                this.GetReportData();
            });
        } else {
            this.setState({ sortField: fieldName, sortFormat: 'A', loading: true }, () => {
                this.GetReportData();
            });
        }
    }

    HandleClose = () => {
        this.setState({ ShowHistory: false });
    }
    componentDidMount() {
        let user = JSON.parse(localStorage.getItem('userData'));
        this.setState({
            companyId: user.companyId,
            loading: true
        }, () => {
            this.props.GetReportReviewedHistory(user.companyId,ReportType.OutstandingTransection)
            this.GetReportData();
            this.props.Accounts(user.companyId);
        });
    }

    ChangePageSize = (size) => {

        this.setState({ loading: true, PageSize: parseInt(size), PageNo: 1 }, () => {
            this.GetReportData();
        });
    }

    ChangePage = (page) => {
        this.setState({ loading: true, PageNo: page, }, () => {
            this.GetReportData();
        });
    }

    LoadComments = (item) => {
        this.setState({ IsCommentModelOpen: true, CommentReferenceId: item.id });
    }

    CloseComments = () => {
        this.setState({ IsCommentModelOpen: false });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.ReportData !== this.props.ReportData) {
            if (nextProps.ReportData.transactionStatus === 0) {
                var totalrecords = 0;
                if (nextProps.ReportData.returnObject != null && nextProps.ReportData.returnObject.length > 0) {
                    totalrecords = nextProps.ReportData.returnObject[0].totalrows
                }

                this.setState({ MissingData: nextProps.ReportData.returnObject, TotalRecords: totalrecords, PageSize: this.state.PageSize, PageNo: this.state.PageNo, loading: false, editIndex: -1 });
            } else {
                toast.error(nextProps.ReportData.resultMsg);
                this.setState({ loading: false });
            }
        }
        if (nextProps.LEDGER_UPDATE !== undefined && nextProps.LEDGER_UPDATE !== this.props.LEDGER_UPDATE) {
            handleLedgerResult(this, nextProps.LEDGER_UPDATE);
        }
        if (nextProps.UpdateDescription !== undefined && nextProps.UpdateDescription !== this.props.UpdateDescription) {
            handleMemoResult(this, nextProps.UpdateDescription);
        }
        if (nextProps.accounts !== this.props.accounts && nextProps.accounts && nextProps.accounts.data) {
            this.setState({ accounts: nextProps.accounts.data, accountOptions: toAccountOptions(nextProps.accounts.data) });
        }
        if (nextProps.ReportReviewdHistory !== undefined && nextProps.ReportReviewdHistory !== this.props.ReportReviewdHistory) {
            if (nextProps.ReportReviewdHistory.transactionStatus === 0) {
                this.setState({ShowHistory: true,HistoryData:nextProps.ReportReviewdHistory.returnObject});
            }
        }
        if (nextProps.CommonUpdate !== undefined && nextProps.CommonUpdate !== this.props.CommonUpdate) {
            if (nextProps.CommonUpdate.transactionStatus === 0) {
                //   let data = this.state.ReportData;
                //   if (this.state.IsReviewProcessing == false) {
                //     let obj = this.state.editedData;
                //     data.map((item, index) => {
                //       if (item.listID === obj.listID) {
                //         item.vendor1099 = obj.vendor1099
                //       }
                //     })

                //     this.setState({editedData: null, IsReviewProcessing: false, reportData: data }, () => { toast.success("Request Process Successfully");
                //     // this.GetReportData();
                //    });
                //   }
                //   else {
                this.setState({ IsReviewProcessing: false}, () => {
                    toast.success("Reviewed Successfully");
                    this.props.GetReportReviewedHistory(this.state.companyId,ReportType.OutstandingTransection)
                });
                //   }
            }
            else {
                this.setState({ loading: false }, () => { toast.error(`${nextProps.CommonUpdate.resultMsg}`); });
            }

        }
    }

    onRefreshDataClick = () => {
        if (!this.state.loading) {
            this.setState({ loading: true }, () => {
                this.GetReportData(true);
            });
        }
    }

    onMarkReviewd = () => {
        this.setState({
            // IsReviewProcessing: true,
            //  loading: true
            loading: false
        }, () => {
            this.props.MarkReportReview(this.state.companyId,ReportType.OutstandingTransection);
        });
    }

    GetReportData(IsRefresh = false) {
        let state = this.state;
        let body = {
            companyID: state.companyId,
            reportType: ReportType.OutstandingTransection,
            fromDate: moment(state.sDate).format("MM/DD/YYYY"),
            toDate: moment(state.eDate).format("MM/DD/YYYY"),
            sortField: state.sortField,
            sortFormat: state.sortFormat,
            pageNumber: state.PageNo,
            pageSize: state.PageSize,
            needUpdatQBORecords: IsRefresh
        };

        this.props.GET_REPORT_DATA(body);
    }

    onLinkClick = (rowData) => {
        let origin = makeLinkForQuickbooks();
        window.open(origin + rowData.transactionLink);
    }


    UpdateItemCommentCount = (id, clearUnread) => {
        let data = this.state.MissingData;
        data.forEach(function (item) {

            if (item.id === id) {
                // clearUnread=true zeros the badge after the comment modal is closed or reviewed
                if (clearUnread === true) { item.unreviewCommentCount = 0; } else { item.commentCount++ }
            } });

        this.setState({ MissingData: data });
    }

    render() {
        return (
            <React.Fragment>
                {/* {this.state.ShowHistory && this.state.HistoryData != null && this.state.HistoryData.length > 0 &&
                    <React.Fragment>
                        <Dialog
                            className="comment-Top-align"
                            maxWidth="sm"
                            fullWidth={true}
                            open={true}>
                            <React.Fragment>
                                <div className="Comments modal-header"><span className="log-history-title float-left">Reviewed History </span>
                                    <Button className="jr-btn close-btn float-right" onClick={this.HandleClose}><ClearIcon /></Button>
                                </div>
                                <DialogContent>
                                    {this.state.HistoryData.length == 0 ?
                                        <div className="history-box">
                                            <p className="history-item-text">No History Found</p>
                                        </div>
                                        :
                                        <React.Fragment>
                                            {this.state.HistoryData.map((item, i) => (
                                                <div className="history-box"> */}
                                                    {/* <p className="history-item-text">
                           
                          </p>
                           */}
                                                    {/* <p className="history-date-text"> <strong style={{ color: "black" }}>  Last Reviewed  </strong> By <strong> {item.userName}</strong> <strong> on </strong>{item.stCreatedDate}</p>
                                                </div>
                                            ))}
                                        </React.Fragment>
                                    }
                                </DialogContent>
                            </React.Fragment>
                        </Dialog>
                    </React.Fragment>

                } */}
                {this.state.IsCommentModelOpen ?
                    <CommonComments
                        CloseComments={this.CloseComments}
                        ColorCode={this.state.ColorCode}
                        ModuleType={ModuleType.GeneralReportType}
                        ReportType={ReportType.OutstandingTransection}
                        CompanyId={this.state.companyId}
                        RecordId={this.state.CommentReferenceId}
                        IsEmbeddedPage={this.state.IsEmbeddedPage}
                        UpdateItemCommentCount={this.UpdateItemCommentCount}
                                SilentRefreshData={() => { if (typeof this.GetReportData === "function") { this.GetReportData(false); } else if (typeof this.GetQuestions === "function") { this.GetQuestions(); } else if (typeof this.getGLData === "function") { this.getGLData(); } }}

                    >
                    </CommonComments> : ""}


                <div className="dashboardPage data-entry-issues-page oo-tran-page">
                    <div className="page-heading page-title-box d-sm-flex justify-content-sm-between align-items-sm-center">
                        <h2 className="title mb-3 mb-sm-0">{JSON.parse(localStorage.getItem('userData')) != null ? JSON.parse(localStorage.getItem('userData')).companyName : ""} | {LinkType.OOTran}</h2>
                    </div>

                    <div className="note-section" style={{ marginBottom: '2px', padding: '15px 25px' }}>
                        <h5 style={{ fontSize: '19px', color: '#334c5a', margin: 0, lineHeight: '1.5',fontWeight:'600' }}>
                            <strong>Notes:</strong> <span className="oo-tran-note-text">The data for this page is synchronized with QuickBooks Online after 12:00am CST. Your corrections in QuickBooks Online for old outstanding transactions will appear in the Compliance Center tomorrow morning.</span>
                        </h5>
                    </div>
                    {this.state.loading ? <CircularProgress /> :
                        <div className="padding-box app-wrapper">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="float-right">
                                        <Button variant="contained" className="graycolor jr-btn bg-teal text-white refresh-btn" onClick={() => this.onMarkReviewd()}>Mark as Reviewed</Button>
                                        {/* <Button variant="contained" className="share-btn jr-btn bg-teal text-white refresh-btn" onClick={() => this.onRefreshDataClick()}  ><i className="zmdi zmdi-refresh "></i> Refresh Data</Button> */}

                                    </div>
                                    {/* <div className="row">
                                        <div className="col-md-8">
                                        </div>
                                        </div> */}
                                </div>
                            </div>
                            <div className="table-responsive-material">
                                <table className="table tablebox account-reconcilliation dei-txn-table">
                                    <thead  >
                                        <tr style={{ backgroundColor: this.state.ColorCode }}>
                                            <th className={`td-width ${this.state.sortField == 'date' ? this.state.sortFormat == 'A'
                                                ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('date')}><p className="table-th-title"> Date</p> </th>
                                            <th className={`td-width ${this.state.sortField == 'transactionType' ? this.state.sortFormat == 'A'
                                                ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('transactionType')}><p className="table-th-title"> Type</p></th>
                                            <th className={`td-width-amount ${this.state.sortField == 'num' ? this.state.sortFormat == 'A'
                                                ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('num')}><p className="table-th-title"> Number</p></th>
                                            <th className={`td-width ${this.state.sortField == 'name' ? this.state.sortFormat == 'A'
                                                ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('name')}><p className="table-th-title"> Name</p></th>
                                            <th className={` ${this.state.sortField == 'memoOrDescription' ? this.state.sortFormat == 'A'
                                                ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('memoOrDescription')}><p className="table-th-title"> Memo/Description</p></th>
                                            <th className={`td-width-amount text-center  ${this.state.sortField == 'amount' ? this.state.sortFormat == 'A'
                                                ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('amount')}><p className="table-th-title"> Amount</p></th>
                                            <th className={`td-width-box ${this.state.sortField == 'account' ? this.state.sortFormat == 'A'
                                                ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('account')}><p className="table-th-title"> Account #</p></th>
                                            <th className={`td-width ${this.state.sortField == 'internalNotes' ? this.state.sortFormat == 'A'
                                                ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('internalNotes')}><p className="table-th-title">Internal Notes</p></th>
                                            <th className={`td-width ${this.state.sortField == 'accountantComment' ? this.state.sortFormat == 'A'
                                                ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('accountantComment')}><p className="table-th-title">Questions and Comments</p></th>
                                            <th className={`td-width ${this.state.sortField == 'newAccount' ? this.state.sortFormat == 'A'
                                                ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('newAccount')}><p className="table-th-title">New Account #</p></th>
                                            <th className="text-center dei-flag-col"><p className="table-th-title dei-flag-title">TFB</p></th>
                                            <th className="text-center dei-flag-col"><p className="table-th-title dei-flag-title">NBD</p></th>

                                            <th className="td-width-90 text-center"><img src="/vendors/WhiteCommnet.png" alt="comments" /></th>
                                            <th className="td-width-90 text-center "><img src="/vendors/Link-arrow_header.png" alt="link" /></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {(this.state.MissingData && this.state.MissingData.length > 0) && this.state.MissingData.map((item, j) => (
                                            <React.Fragment key={j}>
                                                {<tr className="dei-clickable" onClick={() => this.onRowClick(j)}>
                                                    <td title={item.date || ''}>{item.date}</td>
                                                    <td title={item.transactionType || ''}>{item.transactionType}</td>
                                                    <td title={item.num || ''}>{item.num}</td>
                                                    <td title={item.name || ''}>{item.name}</td>
                                                    <td title={item.memoOrDescription || ''}>{item.memoOrDescription}</td>
                                                    <td className="text-center">{numberWithCommas(item.amount)}</td>
                                                    <td title={item.account || ''}>{item.account}</td>
                                                    <td title={item.internalNotes || ''}>{item.internalNotes}</td>
                                                    <td title={item.accountantComment || ''}>{item.accountantComment}</td>
                                                    <td title={formatNewAccountLabel(item, this.state.accounts)}>{formatNewAccountLabel(item, this.state.accounts)}</td>
                                                    <td className="text-center">{item.taxableFringeBenefit ? <Tooltip title="Taxable Fringe Benefit" placement="top-start"><i className="zmdi zmdi-check"></i></Tooltip> : ''}</td>
                                                    <td className="text-center">{item.needsBetterDescription ? <Tooltip title="Needs Better Description" placement="top-start"><i className="zmdi zmdi-check"></i></Tooltip> : ''}</td>
                                                    <td className="text-center" onClick={(e) => e.stopPropagation()}>
                                                        <div className="panel-commentCount">
                                                            <img className={item.commentCount === 0 ? "disableCommentsOpacity" : ""} src="/vendors/Vector Smart Object.png" alt="New Comments" onClick={() => this.LoadComments(item)}></img>
                                                            {item.unreviewCommentCount !== 0 && <span className="badge badge-pill badge-danger ng-star-inserted">{item.unreviewCommentCount}</span>}
                                                        </div>
                                                    </td>
                                                    <td className="text-center" onClick={(e) => e.stopPropagation()}><img src="/vendors/Shape 1.png" alt="QBDlink" onClick={() => this.onLinkClick(item)}></img></td>
                                                </tr>}
                                                {this.state.editIndex === j &&
                                                    <TransactionEditRow
                                                        item={item}
                                                        rowKey={item.id}
                                                        colSpan={14}
                                                        accountOptions={this.state.accountOptions}
                                                        onSave={(editData) => this.onRowSave(item, editData)}
                                                        onCancel={() => this.setState({ editIndex: -1 })}
                                                    />}
                                            </React.Fragment>
                                        ))}

                                        {this.state.MissingData.length == 0 ?
                                            <tr>
                                                <td className="text-center" colSpan="14">
                                                    No issues here! Keep up the good work!
                                                </td>
                                            </tr>
                                            : null}
                                    </tbody>
                                </table>
                            </div>
                            <PaginationComponent
                                selectedPageNo={this.state.PageNo}
                                selectedSize={this.state.PageSize}
                                TotalRecords={this.state.TotalRecords}
                                ChangePageSize={this.ChangePageSize}
                                ChangePage={this.ChangePage}
                                CurrentRecords={this.state.MissingData.length}
                            >
                            </PaginationComponent>
                        </div>
                    }
                </div>

            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        ReportData: state.ReportData.ReportData,
        CommonUpdate: state.ledgers.CommonUpdate,
        ReportReviewdHistory:state.ledgers.ReportReviewedHistory,
        UpdateDescription: state.ReportData.UpdateDescription,
        LEDGER_UPDATE: state.ledgers.LEDGER_UPDATE,
        accounts: state.accounts.accountsData
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        GET_REPORT_DATA,
        MarkReportReview,
        GetReportReviewedHistory,
        LedgerUpdate,
        UPDATE_DESCRIPTION_DATA,
        Accounts
    }, dispatch)
}


export default connect(mapStateToProps, mapDispatchToProps)(OOTranComponent);